export enum TypeVisionCheckin {
    GLOBAL_VISION = 0,  
    GROUP_VISION = 1,  
}